export default {
  path: "/SectionContent/UnitOperatorDetails",
  name: "Unit/Operator Details",
  htmlContent: "unit_operator_details.html",
  headings: [
    { id: "UnitIdentification", text: "Unit Identification", type: "heading" },
    { id: "DriverInformation", text: "Driver Information", type: "heading" },
    { id: "n24Name", text: "24. Name", type: "field" },
    { id: "n25Address", text: "25. Address", type: "field" },
    { id: "n26DOB", text: "26. DOB", type: "field" },
    { id: "n30TelephoneNumber", text: "30. Telephone Number", type: "field" },
    { id: "DriverLicenseInformation", text: "Driver License Information", type: "heading" },
    { id: "n27DriverSLicense", text: "27. Driver's License # ", type: "field" },
    { id: "InsuranceInformation", text: "Insurance Information", type: "heading" },
    { id: "n28InsuranceCompany", text: "28. Insurance Company # ", type: "field" },
    { id: "n29PolicyNumber", text: "29. Policy Number ", type: "field" },
    { id: "OperatorDetails", text: "Operator Details", type: "heading" },
    { id: "n40AlcoholTest", text: "40. Alcohol Test", type: "field" },
    { id: "n41Type", text: "41. Type ", type: "field" },
    { id: "n42Results", text: "42. Results ", type: "field" },
    { id: "n43DrugTest", text: "43. Drug Test", type: "field" },
    { id: "n44Type", text: "44. Type ", type: "field" },
    { id: "n45Results", text: "45. Results ", type: "field" },
    { id: "n48OperatorPedCondition", text: "48. Operator / Ped Condition", type: "field" },
    { id: "n69Citation", text: "69. Citation # ", type: "field" },
    { id: "n70OCGA", text: "70. OCGA ", type: "field" },
  ],
};
